import { useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid,
  InputAdornment, IconButton, Tooltip, CircularProgress,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import * as clientesApi from '../../api/clientes'
import { useNotify } from '../../components/Notifications'

// Alta rápida de cliente con consulta RUC (GET /clientes/consultaruc).
export default function ClienteAltaModal({ open, onClose, onCreated }) {
  const notify = useNotify()
  const [form, setForm] = useState({ numeroDocumento: '', nombre: '', nombreFantasia: '', direccion: '', telefono: '', email: '' })
  const [consultando, setConsultando] = useState(false)
  const [guardando, setGuardando] = useState(false)

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }))

  const consultarRuc = async () => {
    if (!form.numeroDocumento) return
    setConsultando(true)
    try {
      const res = await clientesApi.consultaRuc(form.numeroDocumento)
      const data = res?.data || res
      if (data) {
        set('nombre', data.razonSocial || data.nombre || form.nombre)
        notify.success('RUC encontrado en SET.')
      } else {
        notify.warning('No se encontró el RUC en SET.')
      }
    } catch {
      notify.error('No se pudo consultar el RUC.')
    } finally {
      setConsultando(false)
    }
  }

  const guardar = async () => {
    if (!form.numeroDocumento || !form.nombre) { notify.error('Documento y nombre son obligatorios.'); return }
    setGuardando(true)
    try {
      const created = await clientesApi.crearCliente(form)
      notify.success('Cliente creado.')
      onCreated?.(created)
      onClose()
    } catch (e) {
      notify.error(e?.response?.data?.message || 'No se pudo crear el cliente.')
    } finally {
      setGuardando(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Nuevo cliente</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth size="small" label="RUC / Documento *" value={form.numeroDocumento}
              onChange={(e) => set('numeroDocumento', e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="Consultar RUC en SET">
                      <span><IconButton size="small" onClick={consultarRuc} disabled={consultando || !form.numeroDocumento}>
                        {consultando ? <CircularProgress size={18} /> : <SearchIcon fontSize="small" />}
                      </IconButton></span>
                    </Tooltip>
                  </InputAdornment>
                ),
              }} />
          </Grid>
          <Grid item xs={12} sm={6}><TextField fullWidth size="small" label="Nombre / Razón social *" value={form.nombre} onChange={(e) => set('nombre', e.target.value)} /></Grid>
          <Grid item xs={12} sm={6}><TextField fullWidth size="small" label="Nombre fantasía" value={form.nombreFantasia} onChange={(e) => set('nombreFantasia', e.target.value)} /></Grid>
          <Grid item xs={12} sm={6}><TextField fullWidth size="small" label="Teléfono" value={form.telefono} onChange={(e) => set('telefono', e.target.value)} /></Grid>
          <Grid item xs={12}><TextField fullWidth size="small" label="Dirección" value={form.direccion} onChange={(e) => set('direccion', e.target.value)} /></Grid>
          <Grid item xs={12}><TextField fullWidth size="small" label="Email" value={form.email} onChange={(e) => set('email', e.target.value)} /></Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" color="secondary" onClick={guardar} disabled={guardando}>Guardar</Button>
      </DialogActions>
    </Dialog>
  )
}
